export const skipFields = [
    'Lead_ID',
    'wsapp_recent_activity',
    'wsapp_convo_status',
    'wsapp_unread_count',
    'wsapp_optin_status',
    'wsapp_recent_msg_id',
    'wsapp_enabled',
    'wsapp_blocked',
    'wsapp_opt',
    'wsapp_last_delivered',
    'wsapp_last_read',
    'wsapp_last_replied',
    'wsapp_last_sent_msg_id',
    'wsapp_last_sent_msg_id',
    'wsapp_completed_campaign'
];